import type { PartialDeep } from 'type-fest';
import { Configuration } from '../defaultConfig';

const stageConfig: PartialDeep<Configuration> = {
  services: {
    civicAnalytics: {
      endpoint: 'https://dev.api.civic.com/analytics-preprod/events',
      // 'source' is how the analytics-proxy knows where to route our events.
      // Same as the componentTag but renamed now that we're no longer tied to CML / Segment for generic event streams.
      // Since the analytics endpoint can now ingest events from multiple sources (it lives with analytics-proxy), the source name has to be sent through by each client.
      // We still use 'passApi' instead of 'passIframe' until we can migrate the legacy Redshift data.
      // The source currently maps to a Segment source, which is used as the Redshift schema which we are not renaming right now.
      source: 'passApi_preprod',
    },
    configEndpoint: 'https://dev.api.civic.com/cw-services-preprod/browser-configs',
    networkRetryConfig: {
      defaultRetries: 1,
      userControlledRetries: 1,
      retryTimeoutMs: {
        1: 1,
        2: 1,
        3: 1,
        4: 1,
      },
      maxAllowedRetryLoops: 1,
    },
    captchaKeys: {
      hCaptchaKey: '20000000-ffff-ffff-ffff-000000000002',
      // testing key: always returns score 1 with no challenge and no domain check
      reCaptchaKey: '6LfrZTYlAAAAAH6EUETaBNTuif8tXbU7lD5wsdDT',
    },
    validation: {
      // authEndpoint: 'https://d1ljee3mziygvy.cloudfront.net', // lambda@edge
      authEndpoint: 'https://dev.api.civic.com/sign-preprod', // lambda
      validationEndpoint: 'https://dev.api.civic.com/pass-preprod',
      pollingIntervalInSeconds: 1,
    },
    retention: {
      retentionEndpoint: 'http://localhost:3001/dev/retention',
    },
    uniqueness: {
      revocationPortalUrl: 'https://revoke-preprod.civic.com/uniqueness',
    },
    facetecProductionMode: false,
  },
};

export default stageConfig;
